
import { OK } from 'http-status-codes'
import getAxiosInstance from '../../../helpers/get_axios_instance'

export class TablaDetallePorCondicionLinea12Service {
  static async getDataTablaDetallePorCondicionLinea12 () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_etiqueta_sector12')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 1-2.')
      return (data)
    })
  }

  static async getDataTablaDetallePorCondicionLinea12Total () {
    const axios = getAxiosInstance()
    const promise = axios.get('/consulta_neto_etiqueta_sector12_total')
    return promise.then((result) => {
      const { status, data } = result
      if (status !== OK) throw new Error('No se pudo obtener el reporte de tabla distribucion por cereal sector 1-2.')
      return (data)
    })
  }
}
